<div class="float-drag" cdkDrag>

	<div class="float-container">
        <div class="float-header" cdkDragHandle>
			<div class="header-text">Map Bookmark Manager</div>
			<i class="glyphicons glyphicons-remove" (click)="close()"></i>
        </div>

		<div class="bookmark-content">
			<div class="bookmark-list">
				<div *ngFor="let col of columns; let idx = index;" class="bookmark-column">
					<div class="bookmark-header">
						{{col.name}}
					</div>
					<div *ngFor="let bm of bookmarkList; let idx2 = index" class="bookmark-cell">
						<ng-container *ngIf="col.prop!=='name'&&col.prop!=='search'&&col.prop!=='delete'">{{bm[col.prop]}}</ng-container>
						<ng-container *ngIf="col.prop==='name'">
							<div title="Description: {{bm.desc}}">
								{{bm[col.prop]}}
							</div>
						</ng-container>
						<ng-container *ngIf="col.prop==='search'">
							<div title="Go to bookmark">
								<i class="glyphicons glyphicons-search" (click)="goToBookmark(bm)"></i>
							</div>
						</ng-container>
						<ng-container *ngIf="col.prop==='delete'">
							<div>
								<i *ngIf="userName===bm.userName" class="glyphicons glyphicons-bin" title="Delete bookmark" [ngClass]="{'disabled-icon': bm.id===deletingId}" (click)="deleteBookmark(bm)"></i>
							</div>
						</ng-container>
					</div>
				</div>
				<!-- <app-common-datagrid
					[columns]="columns"
					[rows]="bookmarkList"
					[hidePaging]="true"
				></app-common-datagrid> -->
			</div>
			<div class="bookmark-add">
				<div class="same-line prop-line">
					<div class="bookmark-prop">
						<label>Name</label>
						<input required name="bookmarkName" [(ngModel)]="bookmarkName">
					</div>
					<div class="bookmark-prop">
						<label>Visibility</label>
						<select required name="bookmarkVisibility" [(ngModel)]="bookmarkVisib">
							<option *ngFor="let op of bookmarkVisibilities" [ngValue]="op.value">{{op.label}}</option>
						</select>
					</div>
				</div>
				<div>
					<div class="bookmark-prop">
						<label>Description</label>
						<input required name="bookmarkDesc" [(ngModel)]="bookmarkDesc">
					</div>
				</div>
				<div>
					<div class="bookmark-prop">
						<label>Bbox</label>
						<input disabled name="bookmarkBbox" [(ngModel)]="bookmarkBboxStr">
					</div>
				</div>
				<div class="button-group">
					<button class="button-general" [disabled]="!bookmarkName||!bookmarkVisib||!bookmarkDesc||isAdding" (click)="addBookmark()">Add</button>
				</div>
			</div>
		</div>


	</div>
</div>

<!-- <ng-template #searchCellTempl let-row="row">
	<div title="Go to bookmark">
		<i class="glyphicons glyphicons-search" (click)="goToBookmark(row)"></i>
	</div>
</ng-template>
<ng-template #deleteCellTempl let-row="row">
	<div title="Delete bookmark">
		<i class="glyphicons glyphicons-bin" (click)="deleteBookmark(row)"></i>
	</div>
</ng-template> -->